import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'physicianRec', 'physicianRecHint', 'patientRemarks', 'patientRemarksHint']

  connect() {
    this.syncRequired()
  }

  toggle() {
    if (this.checkboxTarget.checked && this.checkboxTarget.dataset.recommended === 'true' && !this.physicianRecTarget.value) {
      this.physicianRecTarget.value = 'Y'
    }
    this.syncRequired()
  }

  syncRequired() {
    const required = this.checkboxTarget.checked
    this.physicianRecTarget.required = required
    this.patientRemarksTarget.required = required
    this.physicianRecHintTarget.classList.toggle('hidden', !required || !!this.physicianRecTarget.value)
    this.patientRemarksHintTarget.classList.toggle('hidden', !required || !!this.patientRemarksTarget.value)
    this.physicianRecTarget.classList.toggle('border-red-500', required && !this.physicianRecTarget.value)
    this.patientRemarksTarget.classList.toggle('border-red-500', required && !this.patientRemarksTarget.value)
  }
}
